import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["attributeElement"];

  static values = { 
    attributeName: Array, 
    from: { type: Object, default: {} }, // starting value
    to: { type: Object, default: {} }
  };

  toggle() {
    this.attributeNameValue.forEach((attributeName) => {
      this.attributeElementTargets.forEach((element) => {
        if (this.currentAttributeValue(element, attributeName) === this.toValue[attributeName]) {
          this.setFromValue(element, attributeName);
        } else {
          this.setToValue(element, attributeName);
        }
      });
    });
  }

  setToValue(element, attributeName) {
    if (this.toValue[attributeName] === "") {
      element.removeAttribute(attributeName);
    } else {
      element.setAttribute(attributeName, this.toValue[attributeName]);
    }
  }

  setFromValue(element, attributeName) {
    if (this.fromValue[attributeName] === "") {
      element.removeAttribute(attributeName);
    } else {
      element.setAttribute(attributeName, this.fromValue[attributeName]);
    }
  }

  currentAttributeValue(element, attributeName) {
    const value = element.getAttribute(attributeName);
    return value === null ? "" : value;
  }
}
